/*
 * The code is borrowed from https://gomakethings.com/how-to-serialize-form-data-with-vanilla-js
 * and adapted to feet our needs.
 */

const IGNORED_INPUT_TYPES = ['file', 'reset', 'submit', 'button', 'hidden']

export function formData(form) {
  // Setup our serialized data
  const hsh = {}

  // Loop through each field in the form
  for (let i = 0; i < form.elements.length; i++) {
    let field = form.elements[i]

    // Don't serialize fields without a name, submits, buttons, file and reset inputs, hidden and disabled fields
    if (field.name && !field.disabled && IGNORED_INPUT_TYPES.indexOf(field.type) === -1) {
      // If a multi-select, get all selections
      if (field.type === 'select-multiple') {
        hsh[field.name] = []
        for (let n = 0; n < field.options.length; n++) {
          if (field.options[n].selected) {
            hsh[field.name].push(field.options[n].value)
          }
        }
      } else if (field.type !== 'radio' || field.checked) {
        hsh[field.name] = field.value
      }
    }
  }

  return hsh
}



// WEBPACK FOOTER //
// ./app/common/formData.js